import dayjs from "dayjs";
import {IrrigationPlannerDataProps} from "../types/irrigationPlannerDataProps";
import {FieldResult, FieldResultAggregatedProps} from "../types/domain/fieldResult";

const IRRIGATION_PLANNER_DAYS = 7;

export const getIrrigationPlannerData = (fieldResult: FieldResult): IrrigationPlannerDataProps[] => {
    const results: IrrigationPlannerDataProps[] = [];
    const date = dayjs(fieldResult.date);

    for (let i = 0; i <= IRRIGATION_PLANNER_DAYS; i++) {
        const forecastAttr = `aw_fcdp${i}` as keyof FieldResultAggregatedProps;
        const precipitationAttr = `p_fcdp${i}` as keyof FieldResultAggregatedProps;
        results.push({
            date: date.add(i + 1, "days").toDate(),
            irrigationForecast: fieldResult.aggregatedProps[forecastAttr] as number,
            precipitationForecast: fieldResult.aggregatedProps[precipitationAttr] as number,
        });
    }

    return results;
};
